import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale as VantLocale } from 'vant'

import zhCN from './zh-CN.json'
import enUS from './en-US.json'

Vue.use(VueI18n)

const STORAGE_KEY = 'app_locale'

const SUPPORTED_LOCALES = ['zh-CN', 'en-US']

function detectInitialLocale() {
  // 强制英文：忽略浏览器与历史 localStorage 中的语言偏好
  try {
    localStorage.setItem(STORAGE_KEY, 'en-US')
  } catch (e) {
    /* ignore quota / private mode */
  }
  return 'en-US'
}

export const i18n = new VueI18n({
  locale: detectInitialLocale(),
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  },
  silentTranslationWarn: true
})

// Initialize html lang + Vant locale on startup
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', i18n.locale)
}

loadVantLocale(i18n.locale).then(lang => {
  VantLocale.use(i18n.locale, lang)
})

async function loadVantLocale(locale) {
  try {
    if (locale === 'en-US') {
      const mod = await import(/* webpackChunkName: "vant-locale-en" */ 'vant/es/locale/lang/en-US')
      return mod.default || mod
    }
    const mod = await import(/* webpackChunkName: "vant-locale-zh" */ 'vant/es/locale/lang/zh-CN')
    return mod.default || mod
  } catch (e) {
    // Fallback for some bundlers/environments
    if (locale === 'en-US') {
      const mod = await import(/* webpackChunkName: "vant-locale-en" */ 'vant/lib/locale/lang/en-US')
      return mod.default || mod
    }
    const mod = await import(/* webpackChunkName: "vant-locale-zh" */ 'vant/lib/locale/lang/zh-CN')
    return mod.default || mod
  }
}

const DEFAULT_DOCUMENT_TITLE = typeof document !== 'undefined' ? document.title : ''

export function recomputeDocumentTitle(router) {
  if (!router || typeof document === 'undefined') return
  const route = router.currentRoute
  const titleKey = route && route.meta && route.meta.titleKey
  const title = titleKey ? i18n.t(titleKey) : ''
  document.title = title || DEFAULT_DOCUMENT_TITLE
}

export async function setLocale(_locale, { router } = {}) {
  // 仅允许英文界面（调用方传入其它语言也会被忽略）
  const next = 'en-US'

  if (i18n.locale === next) {
    recomputeDocumentTitle(router)
    return
  }

  i18n.locale = next
  try {
    localStorage.setItem(STORAGE_KEY, next)
  } catch (e) {
    /* ignore */
  }

  document.documentElement.setAttribute('lang', next)

  const vantLang = await loadVantLocale(next)
  VantLocale.use(next, vantLang)

  recomputeDocumentTitle(router)
}

export const supportedLocales = SUPPORTED_LOCALES
export const storageKey = STORAGE_KEY
